import { render, staticRenderFns } from "./app-dropdown-button-item.vue?vue&type=template&id=3079b3e1"
import script from "./app-dropdown-button-item.vue?vue&type=script&lang=ts"
export * from "./app-dropdown-button-item.vue?vue&type=script&lang=ts"
import style0 from "./app-dropdown-button-item.vue?vue&type=style&index=0&id=3079b3e1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3079b3e1')) {
      api.createRecord('3079b3e1', component.options)
    } else {
      api.reload('3079b3e1', component.options)
    }
    module.hot.accept("./app-dropdown-button-item.vue?vue&type=template&id=3079b3e1", function () {
      api.rerender('3079b3e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-dropdown-button/app-dropdown-button-item.vue"
export default component.exports